import { useTheme } from '@vitvio/design-system';

export const styledScrollBarProps = {
  '&::-webkit-scrollbar': {
    width: '4px',
    borderRadius: '8px',
    backgroundColor: `transparent)`,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: `gray.300`,
    borderRadius: '8px',
  },
};

export const useStyledScrollBarProps = () => {
  const { getRadius } = useTheme();
  return {
    '&::-webkit-scrollbar': {
      width: '4px',
      borderRadius: getRadius('lg'),
      backgroundColor: `transparent)`,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: `gray.300`,
      borderRadius: getRadius('lg'),
    },
  };
};
